// theme-sources/js/theme/features/cart-fake-item.js

import { fetchConfig } from "../core/utils";
import { logger } from "../core/logger";
import { CART_CONFIG } from "../core/config";

export async function syncCartFakeItem({
  baseState = null,
  sections = [],
  sectionsUrl = window.location.pathname,
} = {}) {
  const safeSections = Array.isArray(sections) ? sections.filter(Boolean) : [];
  const fakeVariantId = Number(CART_CONFIG.FAKE_VARIANT_ID);

  logger.info("CartFakeItem", "start", {
    hasBaseState: !!baseState,
    sections: safeSections,
    fakeVariantId,
  });

  const cartState = await fetch(`${theme.routes.cart_url}`, {
    headers: { Accept: "application/json" },
  }).then((response) => response.json());

  const items = cartState.items || [];

  const fakeItem = items.find((item) => Number(item.id) === fakeVariantId);
  const realItems = items.filter((item) => Number(item.id) !== fakeVariantId);

  const hasSub = realItems.some((item) => !!item.selling_plan_allocation);
  const hasOneTime = realItems.some((item) => !item.selling_plan_allocation);
  const shouldHaveFake = hasSub && !hasOneTime;

  logger.info("CartFakeItem", "analysed", {
    hasSub,
    hasOneTime,
    shouldHaveFake,
    hasFake: !!fakeItem,
  });

  if (shouldHaveFake && !fakeItem) {
    logger.info("CartFakeItem", "adding fake item", { fakeVariantId });

    const response = await fetch(`${theme.routes.cart_add_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        items: [{ id: fakeVariantId, quantity: 1 }],
        sections: safeSections,
        sections_url: sectionsUrl,
      }),
    });

    const payload = await response.json();

    logger.info("CartFakeItem", "fake add response", {
      ok: response.ok,
      status: response.status,
    });

    if (!response.ok) {
      throw new Error(
        `Fake item add failed (${response.status}) ${payload?.description || payload?.message || ""}`,
      );
    }

    return payload;
  }

  if (!shouldHaveFake && fakeItem) {
    logger.info("CartFakeItem", "removing fake item", {
      fakeKey: fakeItem.key,
    });

    const response = await fetch(`${theme.routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        updates: { [fakeItem.key]: 0 },
        sections: safeSections,
        sections_url: sectionsUrl,
      }),
    });

    const payload = await response.json();

    logger.info("CartFakeItem", "fake remove response", {
      ok: response.ok,
      status: response.status,
    });

    if (!response.ok) {
      throw new Error(
        `Fake item remove failed (${response.status}) ${payload?.description || payload?.message || ""}`,
      );
    }
    return payload;
  }

  logger.info("CartFakeItem", "no fake change needed");
  return baseState || cartState;
}
